import type { CustomTheme } from '.'

// TODO upravit schema, bylo jen zkopirovano z Davo
export const customTheme: CustomTheme = {
  colors: {
    primary: {
      DEFAULT: '#00478c',
      '50': '#f4f8fb',
      '100': '#d5e2ee',
      '200': '#b1c8df',
      '300': '#85a9cd',
      '400': '#6c98c3',
      '500': '#4b81b6',
      '600': '#2e6caa',
      '700': '#0d559c',
      '800': '#00478c',
      '900': '#003366',
    },
  },
}
